import glamorous from 'glamorous';
import React from 'react';
import { createPureComponent } from 'module/Common';

const SvgColors = glamorous.svg({
  '& g': {
    fill: '#1D1D1B',
  },
  '&:hover g': {
    fill: '#3B5998',
  },
});

export const FacebookIcon = createPureComponent('FacebookIcon', () => (
  <SvgColors width="16" height="30" viewBox="0 0 16 30" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" fill="none" fillRule="evenodd">
      <g id="A4" transform="translate(-342 -394)">
        <path
          d="M346.6875,423.4052 L346.6875,409.9932 L342.1735,409.9932 L342.1735,404.7642 L346.6875,404.7642 L346.6875,400.9092 C346.6875,396.4352 349.4215,394.0002 353.4115,394.0002 C355.3235,394.0002 356.9665,394.1442 357.4445,394.2062 L357.4445,398.8812 L354.6775,398.8822 C352.5095,398.8822 352.0865,399.9122 352.0865,401.4262 L352.0865,404.7642 L357.2635,404.7642 L356.5885,409.9932 L352.0865,409.9932 L352.0865,423.4052 L346.6875,423.4052 Z"
          id="Fill-3"
        />
      </g>
    </g>
  </SvgColors>
));



// WEBPACK FOOTER //
// ./src/module/View/Menu/icons/FacebookIcon.tsx